import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Button from '../../shared/button.component';
import PeriodDropdown from '../../shared/periodDropdown.component';
import { withPermissions, permissions } from '../../shared/authorization';
import ModalNames from './modalNames';
import { modalDataSelector } from '../../shared/modals/modals.selectors';
import AddBusinessUnitModal from './addBusinessUnitModal.component';
import SecondaryMenu from '../../menu/secondaryMenu.component';
import AddBusinessModal from './addBusinessModal.component';
import { BusinessUnitPropTypes, BusinessUnitsPropTypes } from '../../shared/propTypes/businessUnits';
import HamburgerDropdown from './hamburgerDropdown.component';

import {
  fetchInitialDataForBusinessUnitModal,
  fetchInitialDataForBusinessUnitSettings,
  selectPeriodForBusinessUnitSettings,
  showAddEditModal,
} from './store/actions';
import BusinessUnitSettingsGrid from './businessUnitSettigsGrid.component';
import DeleteBusinessModal from './deleteBusinessUnitModal.component';
import {
  businessCodeOptionsSelector,
  enabledFlagOptionsSelector,
  isLoadingInitialDataForBusinessUnitModalSelector,
} from './store/selectors';
import { OptionsPropTypes } from '../customGroupsPage/propTypes';

const businessModalDataPropType = PropTypes.shape({
  show: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    businessCode: PropTypes.string,
  }),
});

class BusinessUnitSettingsPage extends PureComponent {
  static propTypes = {
    canModifyInSelectedPeriod: PropTypes.bool.isRequired,

    periods: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
    })).isRequired,
    businessUnits: BusinessUnitsPropTypes,
    businessUnitsLoading: PropTypes.bool.isRequired,

    fetchInitialDataForBusinessUnitSettings: PropTypes.func.isRequired,
    selectPeriodForBusinessUnitSettings: PropTypes.func.isRequired,
    showAddEditModal: PropTypes.func.isRequired,

    fetchInitialDataForBusinessUnitModal: PropTypes.func.isRequired,

    addBusinessModalData: businessModalDataPropType,

    addEditModalData: PropTypes.shape({
      show: PropTypes.bool.isRequired,
      data: BusinessUnitPropTypes,
    }),
    deleteModalData: PropTypes.shape({
      show: PropTypes.bool.isRequired,
      data: PropTypes.shape({
        rowIndex: PropTypes.number.isRequired,
        entity: PropTypes.shape({
          businessUnit: PropTypes.string.isRequired,
        }),
      }),
    }),

    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
      taxYear: PropTypes.string.isRequired,
    }),

    enabledFlagOptions: OptionsPropTypes,
    businessCodeOptions: OptionsPropTypes,
    isInitialDataForBusinessUnitModalLoading: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    const { period, fetchInitialDataForBusinessUnitSettings, fetchInitialDataForBusinessUnitModal } = this.props;
    fetchInitialDataForBusinessUnitSettings(period);
    fetchInitialDataForBusinessUnitModal();
  }

  selectPeriod = selectedPeriod => {
    const { periods, selectPeriodForBusinessUnitSettings } = this.props;
    const value = selectedPeriod ? selectedPeriod.value : null;
    selectPeriodForBusinessUnitSettings(
      periods.find(period => period.name === value)
    );
  };

  showAddModal = () => {
    this.props.showAddEditModal();
  };

  onBusinessCodeSave = () => {
    this.props.fetchInitialDataForBusinessUnitModal();
  };

  render() {
    const {
      canModifyInSelectedPeriod,
      period,
      businessUnits,
      businessUnitsLoading,
      addEditModalData,
      deleteModalData,
      addBusinessModalData,
      enabledFlagOptions,
      businessCodeOptions,
      isInitialDataForBusinessUnitModalLoading,
    } = this.props;

    return (
      <div className="business-unit-settings-page">
        <SecondaryMenu>
          <PeriodDropdown
            onChange={this.selectPeriod}
          />
          { canModifyInSelectedPeriod && (
            <div className="hamburger-dropdown ml-auto text-right">
              <HamburgerDropdown />
            </div>
          )}
        </SecondaryMenu>
        <div className="page">
          <div className="container-fluid">
            <div className="row no-gutters page-content-container">
              <div className="col">
                <div className="d-flex flex-row justify-content-between">
                  <h5>Business Units</h5>
                </div>
              </div>
            </div>
            <div className="row no-gutters page-content-container">
              <div className="col">
                <BusinessUnitSettingsGrid
                  componentToRenderOnSearchBar={
                    canModifyInSelectedPeriod
                      ? (
                        <Button
                          type="button"
                          kind="primary"
                          className="a-my-10"
                          onClick={this.showAddModal}
                        >
                          Add Business Unit
                        </Button>
                      ) : null
                  }
                  shouldDisplayAdminColumn={canModifyInSelectedPeriod}
                  businessUnits={businessUnits}
                  businessUnitsLoading={businessUnitsLoading}
                />
              </div>
            </div>
          </div>
        </div>
        <AddBusinessUnitModal
          period={period}
          entityToEdit={addEditModalData.data}
          openForEdit={Boolean(addEditModalData.data)}
          isVisible={addEditModalData.show}
          enabledFlagOptions={enabledFlagOptions}
          businessCodeOptions={businessCodeOptions}
          isLoadingInitialData={isInitialDataForBusinessUnitModalLoading}
        />
        <AddBusinessModal
          isVisible={addBusinessModalData.show}
          onAfterSave={this.onBusinessCodeSave}
        />
        <DeleteBusinessModal
          period={period}
          entityToRemove={deleteModalData.data && deleteModalData.data.entity}
          isVisible={deleteModalData.show}
          rowIndex={deleteModalData.data && deleteModalData.data.rowIndex}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { shared, administration } = state;

  return {
    period: shared.period,
    periods: shared.periods,
    businessUnits: administration.businessUnitSettings.businessUnits,
    businessUnitsLoading: administration.businessUnitSettings.businessUnitsLoading,
    addEditModalData: modalDataSelector(state, ModalNames.BusinessUnitSettingsAddAndEdit),
    deleteModalData: modalDataSelector(state, ModalNames.BusinessUnitSettingsDelete),
    addBusinessModalData: modalDataSelector(state, ModalNames.BusinessAdd),

    enabledFlagOptions: enabledFlagOptionsSelector(state),
    businessCodeOptions: businessCodeOptionsSelector(state),
    isInitialDataForBusinessUnitModalLoading: isLoadingInitialDataForBusinessUnitModalSelector(state),
  };
}

export default withPermissions(permissions.BUSINESS_UNIT_SETTINGS)(connect(
  mapStateToProps,
  {
    fetchInitialDataForBusinessUnitSettings,
    fetchInitialDataForBusinessUnitModal,
    selectPeriodForBusinessUnitSettings,
    showAddEditModal,
  }
)(BusinessUnitSettingsPage));
